/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  segmaent: [],
  counts: [],
  segmentContact: [],
}

const RouteUrl = {
  getTotal: 'tags/tags-withought-pagination',
  GetAllData: 'segment',
  GetData: '',
  EditData: 'segment',
  DeleteData: 'segment/deleteSegment',
  CreateData: 'segment',
  getCounts: 'segment/getSegmentContactCount',
  getSegmentContact: 'segment/getSegmentContactsWithPagination',
}
const thunkName = {
  getToatal: 'segment-total',
  GetAllData: 'segment-GetALLDATA',
  GetData: '',
  EditData: 'segment-update',
  DeleteData: 'segment-Delete',
  CreateData: 'segment-Create',
  getCounts: 'segment-counts',
  getSegmentContact: 'segment-filterContact',
}

// export const GetTotalData: any = createAsyncThunk(thunkName.getToatal, async (data,thunkApi) => {
//   const response = await axios.get(`${API_URL}${RouteUrl.getTotal}`, {
//     params:data,
//     headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
//   })
//   thunkApi.dispatch(stopLoading())
//   return response.data
// })

export const GetCountsOfsegment: any = createAsyncThunk(
  thunkName.getCounts,
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}${RouteUrl.getCounts}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetFilterContactSegment: any = createAsyncThunk(
  thunkName.getSegmentContact,
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}${RouteUrl.getSegmentContact}/${data?.id}`, {
      params: data?.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetAllData: any = createAsyncThunk(thunkName.GetAllData, async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
    params: data,
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  let ids = response?.data?.data?.items?.map((val: any) => val?._id)

  thunkApi.dispatch(
    GetCountsOfsegment({
      segmentIds: ids,
    })
  )
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const DeleteData: any = createAsyncThunk(thunkName.DeleteData, async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}${RouteUrl.DeleteData}`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})
export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
    return response
  }
)

export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.EditData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetFilterContactSegment({id: data?.id}))
  thunkApi.dispatch(GetAllData())
  return response
})
const SegmentData = createSlice({
  name: 'SegmentData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, segmaent: action?.payload}
    })
    builder.addCase(GetCountsOfsegment.fulfilled, (state, action) => {
      return {...state, counts: action?.payload}
    })
    builder.addCase(GetFilterContactSegment.fulfilled, (state, {payload}) => {
      return {...state, segmentContact: payload}
    })
  },
})

export default SegmentData.reducer
